import { useLayoutEffect, useState } from 'react';
import { Router } from 'react-router-dom';

// Uses custom history to be able to navigate outside react (i.e. axios interceptors)
const CustomRouter = ({ history, ...props }) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      {...props}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};

export default CustomRouter;
